// extracted by mini-css-extract-plugin
module.exports = {"FormFooter":"FormFooter_FormFooter__1EH00","FormFooter__left":"FormFooter_FormFooter__left__1AuO5","FormFooter__right":"FormFooter_FormFooter__right__Kgf_g"};